import { getDecodedInstance } from '../getDecodedInstance/getDecodedInstance';
export function isTemplateMode(_ref) {
  let {
    wixCodeApi,
    appParams
  } = _ref;
  return getDecodedInstance({
    wixCodeApi,
    appParams
  }).siteIsTemplate;
}
//# sourceMappingURL=isTemplateMode.js.map